const toBool = (value) => value === "true";

const defaultViewSettings = Object.freeze({
  useFleetDashboard: toBool(process.env.VUE_APP_USES_FLEET_DASHBOARD),
  usesWeatherRoutingView: toBool(process.env.VUE_APP_USES_WEATHER_ROUTING_VIEW),
  usesWeatherTiles: toBool(process.env.VUE_APP_USES_WEATHER_TILES),
  usesNewKDiagramView: toBool(process.env.VUE_APP_USES_NEW_K_DIAGRAM_VIEW),
  usesAlerts: toBool(process.env.VUE_APP_USES_ALERTS),
  usesNewVesselInformationView: toBool(process.env.VUE_APP_USES_NEW_VESSEL_INFORMATION_VIEW),
  canToggleTheme: toBool(process.env.VUE_APP_CAN_TOGGLE_THEME),
  showAverageMeassured: toBool(process.env.VUE_APP_SHOW_AVERAGE_MEASURED),
  //usesCiiView: toBool(process.env.VUE_APP_USES_CII_VIEW),
  //usesKykladesVesselInfoView: toBool(process.env.VUE_APP_USES_KYKLADES_VESSEL_INFO_VIEW),
  //usesArcadiaVesselInfoView: toBool(process.env.VUE_APP_USES_ARCADIA_VESSEL_INFO_VIEW),
  //usesPolembrosVesselInfoView: toBool(process.env.VUE_APP_USES_POLEMBROS_VESSEL_INFO_VIEW),
});

export default defaultViewSettings;
